/**
 * Sorts area candidates from most specific (city) to least specific (state).
 * Used when falling back to reverse geocoding after a breadcrumb area fails to resolve.
 * HP-7240
 */

const AREA_TYPE_PRIORITY: Record<string, number> = {
  city: 0,
  neighborhood: 1,
  borough: 2,
  county: 3,
  zip: 4,
  state: 5,
};

export function sortAreaCandidatesBySpecificity<T extends { type?: string }>(candidates: Array<T>): Array<T> {
  return [...candidates].sort(
    (a, b) => (AREA_TYPE_PRIORITY[a.type ?? ''] ?? 9) - (AREA_TYPE_PRIORITY[b.type ?? ''] ?? 9),
  );
}
